// Mock user data
export const mockUser = {
  id: 1,
  nombre: 'Adrià',
  apellidos: 'Junquera Selma',
  username: 'adrijuse395',
  correo: 'adriajuse@gmail.com',
  fechaNacimiento: '2004-10-26',
  ciudad: 'Barcelona',
  idioma: 'es',
  bio: 'Apasionado por los viajes y los intercambios culturales. Siempre dispuesto a conocer nuevas personas y culturas.',
  interests: ['Viajes', 'Idiomas', 'Fotografía', 'Cocina'],
  languages: ['Español', 'Inglés', 'Català']
};

export const mockUserStats = {
  enrolledEvents: 12,
  organizedEvents: 5,
  ratings: 28
};
